import { useEffect, useState, useRef } from "react";
import { BackGroundModal, ContainerLeftAside } from "../../Styles/Styled";
interface IProd {
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  quantidade: number;
}
interface AsideProps {
  open: boolean;
  onCloseAside: Function;
}

export default function LeftAside(props: AsideProps) {
  const [prodsCart, setProdsCart] = useState<IProd[]>([]);
  const [open, setOpen] = useState(props.open);
  const background = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log(open ? "true 0 " : "false 0");
    setOpen(props.open);
  }, [props]);

  useEffect(() => {
    const handleClick = (e: any) => {
      if (e.target.id === "background-opacity") {
        props.onCloseAside();
      }
    };

    const element = window;

    element.addEventListener("click", handleClick);

    // 👇️ remove the event listener when the component unmounts
    return () => {
      element.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <BackGroundModal open={props.open} id="background-opacity">
      <ContainerLeftAside Open={open} id="LeftAside" />
    </BackGroundModal>
  );
}
